/* eslint-disable @typescript-eslint/ban-ts-comment */

import { Props } from "../../hook";
import { AppPartType } from "../../types";
import ModalSetting from "../Modal/ModalSetting";
import useAppTable from "./hook";
import { Styles } from "./styles";
import Item from "./components/item";
import { DEFAULT_WIDTH_COL } from "../../constants";
import { Spin } from "antd";
import { BUTTON_HEIGHT, CopyTypeAppStore, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { useSelector } from "react-redux";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";
interface IProps extends Props {
  layout?: AppPartType[];
  isAllowUpdateApp?: boolean;
  isLoading?: boolean;
  appCopyType?: keyof typeof CopyTypeAppStore;
}
const AppTable = (props: IProps) => {
  const {
    optionsType,
    handleChangeAppById,
    handleMenuClick,
    dataExistList,
    setEditingAppPart,
    editingAppPart,
    handleUpdateWidth,
    onDragging,
    onDragStopped,
    containerRef,
  } = useAppTable(props);
  const { layout, isAllowUpdateApp, isLoading, appCopyType } = props;
  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;

  return (
    <Styles>
      {layout && (
        <ModalSetting
          appPart={editingAppPart}
          setEditingAppPart={setEditingAppPart}
          isAllowUpdateApp={isAllowUpdateApp}
        />
      )}
      <Spin spinning={!!isLoading}>
        <div
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              width: DEFAULT_WIDTH_COL,
              maxWidth: DEFAULT_WIDTH_COL,
              minWidth: DEFAULT_WIDTH_COL,
              zIndex: 2,
            }}
          >
            <Item
              isFirstRow
              width={DEFAULT_WIDTH_COL}
              handleChangeAppById={handleChangeAppById}
              handleMenuClick={handleMenuClick}
              index={0}
              appPart={layout && layout[0]}
              onDragStopped={() => {}}
            />
          </div>
          <div
            style={{
              display: "flex",
              zIndex: 1,
              paddingRight: 10,
              overflowX: "scroll",
              overflowY: "hidden",
            }}
            ref={containerRef}
          >
            {layout?.map((appPart, index) => {
              return (
                <Item
                  key={appPart.id || appPart.uuid}
                  appCopyType={appCopyType}
                  appPart={appPart}
                  optionsType={optionsType}
                  handleChangeAppById={handleChangeAppById}
                  handleMenuClick={handleMenuClick}
                  dataExistList={dataExistList}
                  isAllowUpdateApp={isAllowUpdateApp}
                  setEditingAppPart={setEditingAppPart}
                  handleUpdateWidth={handleUpdateWidth}
                  index={index}
                  onDragging={onDragging}
                  onDragStopped={onDragStopped}
                />
              );
            })}
          </div>
        </div>
      </Spin>
    </Styles>
  );
};
AppTable.displayName = "AppTable";

export default AppTable;
